<template>
<div id="publicInfo">
    <Header />
    <router-view/>
    <Footer class="mt20" />
</div>
</template>
<script>
import Header from '@/components/common/WebHeader'
import Footer from '@/components/common/Footer'
export default {
    name: 'HaierProduct',
    components:{ Header,Footer },
    created () {
        window.vue=this;
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/publicInfo/PublicInfo.vue